import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { IGetMemberVPosListResponse, GetMemberVPosListRequest } from "./useGetMemberVPosList";


async function getMemberVPosListForMerchantVPosDefinition(): Promise<IGetMemberVPosListResponse> {
  try {

    let dataFromApi = await axiosInstance.post("/MemberVPos/ListWithoutPagination", {});
    let filteredData = dataFromApi?.data?.data?.filter((value: any, index: any, self: any) =>
      index === self.findIndex((t: any) => (
        t?.bankCode === value?.bankCode
      ))
    );
    dataFromApi.data.data = filteredData;
    return dataFromApi.data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMemberVPosListForMerchantVPosDefinition() {
  return useMutation<
    IGetMemberVPosListResponse,
    Error
  >(() => getMemberVPosListForMerchantVPosDefinition());
}